import { render, staticRenderFns } from "./ClientSettingFixedPhraseEdit.vue?vue&type=template&id=37968b2b&scoped=true"
import script from "./ClientSettingFixedPhraseEdit.vue?vue&type=script&lang=js"
export * from "./ClientSettingFixedPhraseEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientSettingFixedPhraseEdit.vue?vue&type=style&index=0&id=37968b2b&prod&lang=css"
import style1 from "./ClientSettingFixedPhraseEdit.vue?vue&type=style&index=1&id=37968b2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37968b2b",
  null
  
)

export default component.exports